import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { isGoodieGiveawayLanding } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-categories.selectors';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import formatPrice from 'swag-common/utils/format-price';
import { GiveawayProductChoice } from 'swag-common/constants/giveaway.constants';
import { totalPriceOfSelectedGoodieProductsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { TOOLTIP_ERROR_MESSAGE, VALIDATION_ERROR_MESSAGES } from 'swag-client-common/constants/validation-error-messages';
import { giveawayLandingSelector } from '../../redux/giveaway-landing/giveaway-landing.selectors';
import { SubmitBlock as Component } from './submit-block';
const GOODIE_ERROR_MESSAGES = {
  GOODIE_EXCEEDED_BUDGET: "You've exceeded the budget. Please adjust the products selected",
  GOODIE_EXCEEDED_BUDGET_WITH_BUDGET_VALUE: budget => `You've exceeded the budget of $${budget}`
};
const giveawayStep = (_, ownProps) => {
  return ownProps.step;
};
const currentLinkBudget = (_, ownProps) => {
  return ownProps.budget || 0;
};
const isGiveawayLandingSelector = createSelector(giveawayLandingSelector, giveawayLanding => Boolean(giveawayLanding));
const giveawayProductChoice = createSelector(giveawayLandingSelector, giveaway => giveaway && giveaway.selectedGiveaway && giveaway.selectedGiveaway.productChoice);
const isGiveChoiceLandingPageSelector = createSelector(isGiveawayLandingSelector, giveawayStep, giveawayProductChoice, (isGiveawayLanding, step, productChoice) => isGiveawayLanding && step === null && productChoice === GiveawayProductChoice.choice);
const isGiveawayLandingSelectedSelector = createSelector(giveawayLandingSelector, giveaway => {
  var _giveaway$selectedIte;
  return Boolean(giveaway && ((_giveaway$selectedIte = giveaway.selectedItems) === null || _giveaway$selectedIte === void 0 ? void 0 : _giveaway$selectedIte.length));
});
const tooltipErrorMessageSelector = createSelector(isGoodieGiveawayLanding, totalPriceOfSelectedGoodieProductsSelector, giveawayStep, currentLinkBudget, isGiveChoiceLandingPageSelector, isGiveawayLandingSelectedSelector, (isGoodieGiveaway, goodieTotalPrice, step, budget, isGiveChoseLandingPage, isGiveawayLandingSelected) => {
  const isBudgetExceed = goodieTotalPrice > budget;
  if (isGoodieGiveaway) {
    if (goodieTotalPrice === 0) {
      return TOOLTIP_ERROR_MESSAGE.SELECT_PRODUCTS;
    }
    if (isBudgetExceed) {
      if (step === GiveawayGoodieSteps.checkout) {
        return GOODIE_ERROR_MESSAGES.GOODIE_EXCEEDED_BUDGET_WITH_BUDGET_VALUE(formatPrice(budget));
      }
      return GOODIE_ERROR_MESSAGES.GOODIE_EXCEEDED_BUDGET;
    }
  }
  if (isGiveChoseLandingPage) {
    return !isGiveawayLandingSelected ? TOOLTIP_ERROR_MESSAGE.SELECT_PRODUCTS : VALIDATION_ERROR_MESSAGES.NOT_VALID_ON_SAVE;
  }
  return VALIDATION_ERROR_MESSAGES.NOT_VALID_ON_SAVE;
});
const mapStateToProps = createStructuredSelector({
  tooltipErrorMessage: tooltipErrorMessageSelector
});
export const SubmitBlock = connect(mapStateToProps, null)(Component);